import { StyleSheet } from "react-native"
import { baseColors, baseFontFamily } from "../../Constants/baseStyles"
import Constants from "expo-constants"
import { basePadding } from "../../Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: baseColors.white,
        elevation: 10,
        paddingHorizontal: basePadding.paddingHorizontal,
        paddingBottom: 7,
        marginTop: -Constants.statusBarHeight,
        paddingTop: Constants.statusBarHeight + 7,

        // HeaderShadow for iOS
        overflow: "visible",
        shadowOffset: { width: 0, height: 10 },
        shadowColor: "#000",
        shadowOpacity: 0.2
    },
    content: {
        alignItems: "center"
    },
    logoStyle: { paddingLeft: RFValue(60) },
    label: {
        marginTop: 5
    }
})

export default styles
